import { condenseImageObject, expandImageObject } from 'utils/globals/imageOptimizatons';

import { ENTITY_TYPES } from 'operabase-router/constants';

export const transformGetCustomerLogos = response => ({
  ...response,
  data:
    response?.data?.map(org => ({
      id: org?.id,
      slug: org?.slug,
      name: org?.name,
      organizationType: org?.organizationType,
      logo: org?.logo?.small || org?.logo?.medium || org?.logo?.large,
    })) || [],
});

export const transformFeaturedHomepageOrganizations = response => {
  const { data } = response || {};

  return {
    ...response,
    data: data?.map(option => ({
      entity: {
        id: option?.id,
        name: option?.name,
        slug: option?.slug,
        source_tag: option?.source_tag,
        organizationType: option?.organizationType,
        city: option?.city,
        country: option?.country,
        logo: condenseImageObject(option?.logo),
        workTypes: option?.workTypes,
      },
      entityType: ENTITY_TYPES.ORGANIZATION,
    })),
  };
};

export const selectFeaturedHomepageOrganizations = response => {
  const { data } = response || {};

  return data?.map(option => ({
    ...option,
    entity: {
      ...option?.entity,
      logo: expandImageObject(option?.entity?.logo),
    },
  }));
};
